import { DefaultService } from '@/services/DefaultService';

export default class MotivoDespesasService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    changeSituacao(id, situacao) {
        return this._http.get(`${this._env}/despesa/despesamotivo/activate/${id}?situacao=${situacao}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(motivodespesa) {
        return this._http.post(`${this._env}/despesa/despesamotivo/updatesituacao`, motivodespesa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column, order, page, limit, situacao, ...params) {
        return this._http.get( encodeURI(`${this._env}/despesa/despesamotivo.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/despesa/despesamotivo/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    save(form) {
        return this._http.post(`${this._env}/despesa/despesamotivo`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });		
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params);
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/despesa/getcombo/despesamotivo.json?situacao=${situacao}&param=${params}`), this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

}